// TimelineItem.jsx
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';

import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftBadge from 'components/SoftBadge';

import { useTimeline } from 'prefabsComponents/Timeline/context';
import {
  timelineItem,
  timelineItemIcon,
} from 'prefabsComponents/Timeline/TimelineItem/styles';

// 👇 importa tu AuthContext
import { AuthContext } from 'context/AuthContext';

function TimelineItem({
  color,
  icon,
  title,
  dateTime,
  description,
  lastItem,
  onDelete,      // función para eliminar
  trackingId     // id del seguimiento
}) {
  const isDark = useTimeline();
  const { hasRole } = useContext(AuthContext);
  const canDelete = hasRole('admin', 'user'); // solo admin/user pueden eliminar

  return (
    <SoftBox position="relative" sx={theme => timelineItem(theme, { lastItem })}>
      <SoftBox
        bgColor={isDark ? 'dark' : 'white'}
        width="1.625rem"
        height="1.625rem"
        borderRadius="50%"
        position="absolute"
        top="3.25%"
        left="2px"
        zIndex={2}
      >
        <Icon sx={theme => timelineItemIcon(theme, { color })}>
          {icon}
        </Icon>
      </SoftBox>
      <SoftBox ml={5.75} pt={description ? 0.7 : 0.5} lineHeight={0} maxWidth="30rem">
        <SoftTypography variant="button" fontWeight="medium" color={isDark ? 'white' : 'dark'}>
          {title}
        </SoftTypography>
        <SoftBox mt={0.5}>
          <SoftTypography variant="caption" fontWeight="medium" color={isDark ? 'secondary' : 'text'}>
            {dateTime}
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={2} mb={1.5}>
          {description ? (
            <SoftTypography variant="button" fontWeight="regular" color="text">
              {description}
            </SoftTypography>
          ) : null}
        </SoftBox>

        {/* Botones */}
        <SoftBox display="flex" justifyContent="flex-start" gap={1}>
          {/* Edit queda oculto como ya lo tenías */}
          <IconButton color="info" size="small" aria-label="editar" hidden>
            <Icon>edit</Icon>
          </IconButton>

          {/* Eliminar: SOLO admin / user */}
          {canDelete && (
            <IconButton
              color="error"
              size="small"
              aria-label="eliminar"
              onClick={() => onDelete(trackingId)}
            >
              <Icon>delete</Icon>
            </IconButton>
          )}
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
}

TimelineItem.defaultProps = {
  color: 'info',
  lastItem: false,
  description: '',
};

TimelineItem.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'dark',
    'light',
  ]),
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  dateTime: PropTypes.string.isRequired,
  description: PropTypes.string,
  lastItem: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  trackingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TimelineItem;
